"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CheckboxInput(_ref) {
  var {
    formik,
    config
  } = _ref;
  var {
    name,
    labelText,
    className,
    helperText,
    validationBucketName
  } = config;
  var helperTextComponent = /*#__PURE__*/_react.default.createElement("p", {
    className: "copy-sm"
  }, helperText);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "".concat(className, " form-group")
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FormCustomControl, {
    inputType: "checkbox",
    id: "ccpa-".concat(name),
    label: labelText,
    checked: formik.values[name],
    feedbackType: "helperText",
    onChange: () => {
      // Add or remove from validationBucket
      var newSelection = [];
      var validationBucket = formik.values[validationBucketName];
      if (!formik.values[name]) {
        newSelection = [...validationBucket];
        newSelection.push(name);
      } else {
        newSelection = validationBucket.filter(el => el != name);
      }
      formik.setFieldValue(name, !formik.values[name]);
      formik.setFieldTouched(validationBucketName, true);
      formik.setFieldValue(validationBucketName, newSelection, true);
    }
  }), helperText ? helperTextComponent : '');
}
var _default = exports.default = CheckboxInput;